module.exports = __webpack_public_path__ + "static/4-merge-commit-963fdf2a48536034a38369af77780de4.svg";